import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import BrandedButton from '../../../../../Buttons/BrandedButton';
const ConfirmButton = (_param)=>/*#__PURE__*/ {
    var { children  } = _param, rest = _object_without_properties(_param, [
        "children"
    ]);
    return React.createElement(BrandedButton, _extends({
        size: "large",
        variant: "brand-green"
    }, rest), children);
};
ConfirmButton.displayName = 'ConfirmButton';
export default ConfirmButton;
